import { Point } from '../../util';

export type LabelCandidate = {
    id: string;
    anchor: Point;
    width: number;
    height: number;
    priority: number;
    padding: number;
    bounds: [number, number, number, number];
};

export type LabelPlacement = {
    offset: Point;
};

export class Placement {
    private readonly labels = new Map<string, LabelCandidate>();
    private lastPlacement: Map<string, LabelPlacement> | null = null;
    private placement: Map<string, LabelPlacement> | null = null;

    add(candidate: LabelCandidate) {
        this.labels.set(candidate.id, candidate);
    }

    get(id: string) {
        return this.placement?.get(id);
    }

    place() {
        this.lastPlacement = this.placement;
        this.placement = new Map<string, LabelPlacement>();
        for (const label of this.labels.values()) {
            this.placement.set(label.id, {
                offset: [0, 0]
            });
        }
    }

    clear() {
        this.labels.clear();
    }
}
